module.exports = __webpack_public_path__ + "45ea32f2e4e029e150d263e3e38e836f.png";